var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import React from 'react'
import styled from 'styled-components'
import { ODIcon, ODIcons } from '../../../../../icons'
import { ODHSpace } from '../../../../layout'
export var ODTag = function (props) {
  var _a = props.tagStyle,
    tagStyle = _a === void 0 ? {} : _a
  return React.createElement(
    TagWrapper,
    { onClick: props.onRemove, style: tagStyle },
    React.createElement(ODIcon, { icon: ODIcons.CoreX }),
    React.createElement(ODHSpace, { w: 5 }),
    props.children
  )
}
var TagWrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  cursor: pointer;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  border-radius: 4px;\n  background-color: var(--second);\n  font-size: 11px;\n  font-weight: bold;\n  color: var(--white);\n  padding-left: 10px;\n  padding-right: 10px;\n',
      ],
      [
        '\n  cursor: pointer;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  border-radius: 4px;\n  background-color: var(--second);\n  font-size: 11px;\n  font-weight: bold;\n  color: var(--white);\n  padding-left: 10px;\n  padding-right: 10px;\n',
      ]
    ))
)
var templateObject_1
//# sourceMappingURL=ODTag.js.map
